/**
 * FAQ accordion.
 *
 * Replaces the previous theme's handler, which looked for `.faq-question`
 * inside `.faq-item` and called addEventListener on the result without a
 * null check. The design's markup uses a `.faq-q` button, so that lookup
 * would have returned null and thrown on every page carrying an FAQ.
 *
 * State lives on the button's aria-expanded and the panel's `hidden`
 * attribute, so assistive tech and the CSS read from the same source
 * rather than from a parallel `.active` class.
 *
 * No optional chaining or nullish coalescing: gulp-babel has no preset
 * configured, so uglify-js parses this as written.
 */
(function () {
  const items = document.querySelectorAll(".faq-item");
  if (!items.length) return;
  for (let i = 0; i < items.length; i++) {
    const btn = items[i].querySelector(".faq-q");
    if (!btn) continue;
    const panelId = btn.getAttribute("aria-controls");
    const panel = panelId ? document.getElementById(panelId) : items[i].querySelector(".faq-a");
    if (!panel) continue;
    btn.addEventListener("click", function () {
      const open = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", open ? "false" : "true");
      // `hidden` rather than a class: it keeps the collapsed answer out of
      // the accessibility tree and out of find-in-page.
      if (open) {
        panel.setAttribute("hidden", "");
      } else {
        panel.removeAttribute("hidden");
      }
    });
  }
})();